import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";


export const getAllVehicleInfo = async(username) => {
    try{
        const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/user/${username}`)
        console.log("the response data in vehicle: ", response);
        return response.data;
    }catch(error){
        console.error(error);
    }
}

export const getVehicleLiveInfoByNo = async(vehicleNo) => {
    try{
        const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/${vehicleNo}`);
        return response.data;
    }catch(error){
        console.error(error);
    }
}

export const getVehicleLiveStats = async() => {
    try{
        const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/stats`);
        return response.data;
    }catch(error){
        console.error(error);
    }
}

export const getAllGpsOfflineVehicleData = async() => {
    try{
        const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/gps-offline-vehicles`);
        return response.data;
    }catch(error){
        console.error(error);
    }
}

export const getVehicleJobProgress = async(vehicleNo) => {
    try{
        const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/progress/${vehicleNo}`);
        return response.data;
    }catch(error) {
        console.error(error);
    }
}

export const getFleetIssueWoDashboardStats = async () => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/issue-wo-stats`
        );
        return response.data;
    } catch (error) {
        console.error(error);
    }
};

export const getVehicleFinanceData = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/fleet/vehicles/live/vehicle-finance-data`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};